// Define variables
var recommendation_container = document.querySelector('[data-custom-recommendations]');
var lastPageReached = false;
var currentPage = 1;
var data = [];
var totalPages = 1;
var recommendationAvailable = true

function noData(){
  document.querySelector('.custom-recommendations h2').classList.add('hidden');
}
// Fetch data from Marsel with pagination
function fetchDataWithPagination(url) {
  try {
    return fetch(`${url}&${new URLSearchParams({ page: currentPage })}`)
      .then(function (response) {
        return response.json();
      })
      .then(function (jsonData) {
        if(jsonData.status == 'error'){
          recommendationAvailable = false
          noData()
          return
        }
        data = data.concat(jsonData.data);
        processFetchedData(jsonData.data);

        totalPages = jsonData.pagination.total_pages;
        var nextPage = jsonData.pagination.next_page;

        // Check if the last page has been reached
        if (currentPage === totalPages) {
          lastPageReached = true;
        }

        console.log(currentPage, totalPages);
        console.log("lastPageReached", lastPageReached);

        currentPage = nextPage;
        return nextPage;
      }).finally(()=>{
        lazy_pop_load();
      });
  } catch (error) {
    console.error('An error occurred while fetching data:', error);
    return Promise.reject(error);
  }
}

// Process the fetched data and display it
function processFetchedData(data) {
  data.forEach(function (response, i) {
    displayResponseObject(response, i);
  });
}

// Display the individual response object in the DOM
function displayResponseObject(response, i) {
  // Create a div element
  var savings = Math.trunc(
    ((response.variants[0].compareAtPrice - response.variants[0].price) * 100) /
    response.variants[0].compareAtPrice
  );
  if (!response.available){
    console.log(response.handle, "unavailable")
    return
  }

  var div = document.createElement('li');
  div.classList = 'grid__item';
  var currentDivID = 'recommended-item-' + (currentPage - 1) + i;
  div.setAttribute('id', currentDivID);

  // Set the innerHTML of the div with the response data
  div.innerHTML = `
    <!-- custom.js---------->
        <div class="card-wrapper" data-handle="${response.handle}" data-available="${response.available}">
            <a href="#" class="iWishAddColl iwishcheck" data-product="${response.id}" data-variant="${response.variants[0].id}">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 378.94 378.94" style="enable-background:new 0 0 378.94 378.94;" xml:space="preserve"><g><path d="M348.151,54.514c-19.883-19.884-46.315-30.826-74.435-30.826c-28.124,0-54.559,10.942-74.449,30.826l-9.798,9.8l-9.798-9.8c-19.884-19.884-46.325-30.826-74.443-30.826c-28.117,0-54.56,10.942-74.442,30.826c-41.049,41.053-41.049,107.848,0,148.885l147.09,147.091c2.405,2.414,5.399,3.892,8.527,4.461c1.049,0.207,2.104,0.303,3.161,0.303c4.161,0,8.329-1.587,11.498-4.764l147.09-147.091C389.203,162.362,389.203,95.567,348.151,54.514z M325.155,180.404L189.47,316.091L53.782,180.404c-28.368-28.364-28.368-74.514,0-102.893c13.741-13.739,32.017-21.296,51.446-21.296c19.431,0,37.702,7.557,51.438,21.296l21.305,21.312c6.107,6.098,16.897,6.098,23.003,0l21.297-21.312c13.737-13.739,32.009-21.296,51.446-21.296c19.431,0,37.701,7.557,51.438,21.296C353.526,105.89,353.526,152.039,325.155,180.404z"></path></g></svg>
            </a>
        <a target="_blank" href="/products/${response.handle}?&amp;pr_rec_pid=${response.id}&amp;pr_src_id=${meta.product.id}" class="full-unstyled-link">
            <span class="visually-hidden">${response.title}</span>
        </a>
        <use-animate data-animate="zoom-fade-small" class="card card--product" tabindex="-1" animate="">
            <a target="_blank" href="/products/${response.handle}?pr_rec_pid=?${response.id}&amp" class="card__media media-wrapper" tabindex="-1">
                <div class="image-animate media media--portrait">
                <img src="${response.imageSrc}&amp;width=900" alt="${response.title}" 
                    srcset="${response.imageSrc}&amp;width=165 165w, ${response.imageSrc}&amp;width=360 360w, ${response.imageSrc}&amp;width=535 535w, ${response.imageSrc}&amp;width=750 750w, ${response.imageSrc}&amp;width=940 940w, ${response.imageSrc}&amp;width=1100 1100w" width="1100" height="1400" loading="lazy" class="motion-reduce" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 10rem) / 4), (min-width: 750px) calc((100vw - 10rem) / 3), calc(100vw - 3rem)" is="lazy-image">
                </div>
            </a>
        </use-animate>

        <div class="card-information">
            <div class="card-information__wrapper"><div class="card-information__top"></div><a target="_blank" href="/products/${response.handle}pr_rec_pid=${response.id}&amp;&amp;pr_seq=uniform" class="card-information__text h4" tabindex="-1">
                ${response.title}
                </a>
            <span class="caption-large light"></span>

            
        <div class="price price--on-sale">
          <dl><div class="price__regular">
            <dt>
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
            </dt>
            <dd>
                <span class="price-item price-item--regular">
                <price-money><bdi><span class="price__prefix">₹</span>${response.variants[0].price}</bdi></price-money>
                </span>
            </dd>
            </div>
              <div class="price__sale"><dt class="price__compare">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                </dt>
                <dd class="price__compare">
                <s class="price-item price-item--regular">
                    <price-money><bdi><span class="price__prefix">₹</span>${response.variants[0].compareAtPrice}</bdi></price-money>
                </s>
                </dd><dt>
                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                </dt>
                <dd>
                <span class="price-item price-item--sale">
                  <price-money><bdi><span class="price__prefix">₹</span>${response.variants[0].price}</bdi></price-money>
                </span>
                </dd>
              </div>
            </dl></div>
            <div class="pop-club-listing" price="${response.variants[0].price}"></div>  
            </div>  
          </div>
          
          <div class="card__badge">
              <span class="badge badge--onsale" aria-hidden="true">${savings}%
            </span>
          </div>
      </div>
    `;
  div.classList.add('recommendation');

  // Append the div to the DOM
  recommendation_container.appendChild(div);
}

// Usage: Intersection Observer to trigger data fetching
document.addEventListener('page:loaded', function () {
  var productId = '';
  if (meta.page.resourceType === 'product') {
    productId = meta.product.id;
  }

  var url = `https://app.marsel.ai/api/recommendations/similar_items?shop=leemboodi-store.myshopify.com&product_id=${productId}`;

  var options = {
    rootMargin: '0px 0px 450px 0px'
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.loaded) {
          entry.target.dataset.loaded = true;
          console.log('Load data when the recommendation container is in view');
          console.log('FETCH INTERSECTION', url);

          // Function to fetch all pages of data
          function fetchAllPages() {
            fetchDataWithPagination(url).then(function (nextPage) {
              if (!lastPageReached && currentPage <= totalPages && recommendationAvailable) {
                fetchAllPages();
              }
            });
          }

          // Start fetching all pages
          fetchAllPages();
        }
      });
    },
    options
  );

  var recommendationContainer = recommendation_container;
  if (recommendationContainer){
  observer.observe(recommendationContainer);
  }
});

function updateVisitorCount() {
  var vistorCountElement = document.querySelector('#vistorCount.product__text strong');
  if (vistorCountElement) {
    // Generate a random integer between 150 and 250
    var randomCount = Math.floor(Math.random() * (250 - 150 + 1)) + 150;

    // Update the vistorCount element's innerText
    vistorCountElement.innerText = randomCount;
  }
}

function updateCurrentHour() {
  var currentHourElement = document.querySelector('#currentHour strong');
  if (currentHourElement) {
    var currentDate = new Date();
    var currentHour = currentDate.getHours();
    var currentMinute = currentDate.getMinutes();

    currentHour = currentHour % 12 || 12;

    // Calculate the total minutes elapsed since 12:00 AM
    var totalMinutes = currentHour * 60 + currentMinute;

    console.log("currentHour", currentHour, "currentMinute", currentMinute,"totalMinutes", totalMinutes)

    // Check if the total minutes are less than 200 (before 3:20 AM)
    var outputValue = totalMinutes < 200 ? 250 + currentMinute : totalMinutes;
    var productId = meta.product.id;
    var lastDigit = productId % 10;
    outputValue += lastDigit;

    // Update the currentHour element's innerText
    currentHourElement.innerText = outputValue;
  }
}

// Initial update when the page loads
updateVisitorCount();
updateCurrentHour();

// Update both functions every 3 seconds
setInterval(function () {
  updateVisitorCount();
  updateCurrentHour();
}, 3000);
